import { Anchor, AnchorProps } from 'ui/components';

export const AnchorFeature: React.FC<Content.Anchor> = ({ content }) => {
	const { anchorName } = content?.properties;

	return (
			<Anchor anchorName={anchorName}></Anchor>
	);
};
